import React from "react";
import { ButtonSize, ButtonType } from "../types";

type Props = {
  onClick: () => void;
  label: string;
  type?: ButtonType;
  size?: ButtonSize;
  icon?: JSX.Element;
  classNames?: string;
};

const Button = (props: Props) => {
  const {
    onClick,
    label,
    type = "primary",
    size = "normal",
    icon = <></>,
    classNames = "",
  } = props;
  const styles = {
    primary: "bg-blue-500 text-white",
    secondary: "bg-green-600 text-white",
    tertiary: "bg-black text-white",
    destructive: "bg-red-600 text-white",
    transparent: "bg-transparent text-gray-800",
    underlined: "bg-transparent underline text-black text-xs",
  }[type];

  const paddings = size === "mini" ? "px-2 py-1" : "px-5 py-3";

  return (
    <button
      className={`${styles} ${paddings} ${classNames} rounded flex flex-row items-center cursor-pointer`}
      onClick={onClick}
    >
      {icon}
      {label}
    </button>
  );
};

export default Button;
